// extracted by mini-css-extract-plugin
export default {"container":"page-section_container__7hHPV"};